import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { URL } from '../../constants/url'
import Loading from '../../components/common/Loading'

import {
  createMicrosoftLink,
} from '../../../states/containers/auth/MicrosoftSyncSlice'

const LoginMicrosoftCallback: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const urlStr = location.href
    const callbackUrl = { callback_url: urlStr }
    dispatch(createMicrosoftLink(callbackUrl,
      () => {
        history.push(URL.LOGIN.path)
      },
      () => {
        history.push(`${URL.LOGIN.path}?deny_sso=true`)
      }))
  }, [location.href])

  return (
    <>
      <Loading />
    </>
  )
}

export default LoginMicrosoftCallback
